import Graph from "../../component/chart/NewLine";
import { useSelector, useDispatch } from "react-redux";
import actions from "../../redux/actions";
import { useEffect } from "react";

export default function LineGraph(props) {
  const graphData = useSelector((state) => state.compareGraph.graphData);
  const graphRendering = useSelector(
    (state) => state.compareGraph.graphRendering
  );

  const dispatch = useDispatch();

  function toggleVisible(name, value) {
    dispatch(actions.compareGraph.setVisible({ name, visible: value }));
  }

  useEffect(() => {
  }, [graphData])
  

  return (
    <div>
      <Graph
        title={"Comparing Data"}
        subtitles={[
          {
            text: props?.formSearch
              ? props?.formSearch?.offset
                ? "ค่าระดับน้ำที่หักค่าเกณฑ์หักน้ำแล้ว"
                : "ค่าระดับน้ำวัดเทียบจากศูนย์บรรทัดน้ำ"
              : "",
            verticalAlign: "top",
            horizontalAlign: "left",
            fontWeight: "bold",
          },
        ]}
        toggleVisible={toggleVisible}
        rendering={graphRendering}
        data={graphData}
        randomLineColor={true}
      />
    </div>
  );
}
